// CustomTextInput.js

import { useState } from 'react';
import { TextField, List, Button, CircularProgress } from '@material-ui/core';
import { getRelatedUser } from './index';
import { RowTable } from './RowTable';
import { useNotify } from "react-admin";
export const validateIranMobile = (value: any): any => {
    const regex = /^09\d{9}$/;
    if (value) {
        if (!regex.test(value)) {
            return "شماره موبایل صحیح نمیباشد";
        }
        return '';
    }
};


export function ManageRelatedOfFiles() {
    const [inputText, setInputText] = useState<any>('');
    const [error, setError] = useState<string>('');
    const [loadingFetch, setLoadingFetch] = useState<any>(false);
    const [formError, setFormError] = useState<string>('');
    const [apiData, setApiData] = useState<any>([]);
    const [allDietTypes, setAllDietTypes] = useState<any>({})
    const [relationTypes,setAllRelationTypes] = useState<any>([])
    const [mainIdentityId,setMainIdentityId] = useState<any>(null)
    const notify = useNotify()
    const handleInputChange = async (event: any) => {
        const { value } = event.target;
        setInputText(value);
        // setError(validateIranMobile(value));
    };
    const fetchData = async () => {
        getRelatedUser(inputText)
            .then((response) => {
                if (response.data.err) {
                    setFormError(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
                    notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
                    setLoadingFetch(false)

                } else {
                    setAllDietTypes(response.data.dietTypes);
                    setAllRelationTypes(response.data.relationTypes)
                    setMainIdentityId(response.data.data.mainIdentityId)
                    setApiData(response.data.data.identities);
                    setLoadingFetch(false)
                }
            })
            .catch((error) => {
                setLoadingFetch(false)
                console.error('Error fetching related users:', error);
            });
    }
    const refetch = () => {
        fetchData()
    }
    const search = async (e: any) => {
        e.preventDefault()
        setApiData([])
        setLoadingFetch(true)
        // if (!error) {
            await fetchData()

        // }
    };

    return (
        <div >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", fontFamily: "IranSans-Medium" }}>
                <form style={{ width: "100%", padding: "2em" }} action="" onSubmit={(e) => search(e)}>

                    <TextField
                        label=" شماره موبایل"
                        value={inputText}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        error={Boolean(error)} // Show error style if there's an error
                        helperText={error} // Display error message
                    />
                    <Button
                        onClick={(e) => search(e)}
                        fullWidth
                        disabled={loadingFetch}
                        type="submit"
                        color="primary"
                        style={{ color: "#fff", marginTop: "10px" }}
                        variant="contained"
                    >

                        {loadingFetch ?
                            <CircularProgress size={20} />
                            :
                            (<span>جستجو</span>)

                        }
                    </Button>
                </form>

            </div>

            {apiData.length > 0 && (
                <List style={{ padding: "5px", marginTop: "20px" }}>
                    {apiData.map((item: any) => (

                        <RowTable key={item.id} item={item} mainIdentityId={mainIdentityId} relationTypes={relationTypes} allDietTypes={allDietTypes} refetch={refetch} />
                    ))}
                </List>
            )}
        </div>
    );
};


